import { ApiError } from '@/lib/api/ApiError';
import { toApiErrorCategory, type ErrorCategory } from './errorCategory';

export const toConsentErrorCategory = (error: unknown): ErrorCategory => {
  if (error instanceof ApiError) return toApiErrorCategory(error.status);

  if (error instanceof TypeError) return 'network';

  return 'unknown';
};
